module.exports = __webpack_public_path__ + "static/media/finkids.246e6e85.png";